import { render, staticRenderFns } from "./SelectedCategories.vue?vue&type=template&id=5f3fabcb&scoped=true"
import script from "./SelectedCategories.vue?vue&type=script&lang=js"
export * from "./SelectedCategories.vue?vue&type=script&lang=js"
import style0 from "./SelectedCategories.vue?vue&type=style&index=0&id=5f3fabcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3fabcb",
  null
  
)

export default component.exports